import { parseAsStringLiteral, useQueryState } from 'nuqs'
import { useTranslation } from 'react-i18next'

import { VariantsInfoAlert } from '@/components/Catalog/VariantsInfoAlert'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { Parameters } from '@/containers/Catalog/Parameters'
import { VariantAxes } from '@/containers/Catalog/VariantAxes'
import { useSetPageHeader } from '@/contexts/PageHeaderContext'

const TABS = ['variants', 'parameters'] as const

export default function CatalogPropertiesPage() {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'catalog',
  })

  const [tab, setTab] = useQueryState('tab', parseAsStringLiteral(TABS).withDefault('variants'))

  useSetPageHeader({
    breadcrumbs: [
      {
        href: '/catalog/products',
        children: t('products.title'),
      },
      {
        href: '/catalog/properties',
        children: t('properties.title'),
      },
    ],
  })

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold">{t('properties.title')}</h1>

      <VariantsInfoAlert />

      <Tabs value={tab} onValueChange={(value) => setTab(value as typeof tab)} variant="outline">
        <TabsList>
          <TabsTrigger value="variants">{t('variantAxes.title')}</TabsTrigger>
          <TabsTrigger value="parameters">{t('parameters.title')}</TabsTrigger>
        </TabsList>
        <TabsContent value="variants">
          <VariantAxes />
        </TabsContent>
        <TabsContent value="parameters">
          <Parameters />
        </TabsContent>
      </Tabs>
    </div>
  )
}
